"use client"
import { BlogSearchProvider } from "@/providers/blogSearchProvider";
import SearchModule from "./SearchModule";
import SearchResults from "./SearchResults";

const BlogSearch =({ initialPosts, prechecked }) => {
    return(
        <>  
            <BlogSearchProvider initialPosts={initialPosts}>
                <SearchModule prechecked={prechecked}/>
                <SearchResults />
            </BlogSearchProvider>
        </>
    );
}

export default BlogSearch;